
/* styles */
require("!!../../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-6ca59365&scoped=true!../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./Branches.vue")

var Component = require("!../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./Branches.vue"),
  /* template */
  require("!!../../../../node_modules/vue-loader/lib/template-compiler?id=data-v-6ca59365!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./Branches.vue"),
  /* scopeId */
  "data-v-6ca59365",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/microfinance/master/company/Branches.vue
// module id = 795
// module chunks = 0